import { createFileRoute } from '@tanstack/react-router'
import { CapexPlanDetail } from '../../../components/capex/CapexPlanDetail'

export const Route = createFileRoute('/$org/capex-plans/$planUid')({
  component: CapexPlanDetailRoute,
})

function CapexPlanDetailRoute() {
  const { org, planUid } = Route.useParams()
  return <CapexPlanDetail org={org} planUid={planUid} />
}
